import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { ImprimirTiritasComponent } from './imprimirTirita.component';
import { ImprimirInformeCabeceraSharedModule } from '../partes/informe-cabecera/imprimir-informe-cabecera.module.share';








@NgModule({
    declarations: [
        ImprimirTiritasComponent
    ],
    imports: [ 
        CommonModule,
        ImprimirInformeCabeceraSharedModule,
        ButtonModule 
    ],
    exports: [ 
        ImprimirTiritasComponent
     ],
    providers: [],
})
export class ImprimirTiritasSharedModule {}